<template>
  <div class="mine">
    <div style="margin: 0 20px;">
      <div class="mine_headers">
        <tabs :tabs-list="tabsList" @tabs="handleTabChange" />
        <div class="date_box">
          <search :model="model" @changeDate="changeDate" :search-list="searchList" />
        </div>
      </div>

    </div>
    <!-- 公共表格 -->
    <div class="table_box">
      <el-table
        ref="table"
        :data="tableData"
        border
        highlight-current-row
        class="scpc-task-table"
        height="100%"
        :header-cell-style="{
          background: '#F1F1F1 ',
          fontSize: '14px',
          color: '#999999'
        }"
        :cell-style="{
          fontSize: '14px',
        }"
        :row-style="{ height: '38' }"
        :style="{
          width: '100%'
        }"
        v-el-table-infinite-scroll="loadList"
        :infinite-scroll-distance="50"
      >
        <!-- 动态列配置 -->
        <el-table-column
          v-for="(column, index) in tableColumns"
          :key="column.prop || index"
          :prop="column.prop"
          :label="column.label"
          :min-width="column.width"
        >
          <!-- 内容 -->
          <template slot-scope="scope">
            <span style="white-space: pre-wrap;">{{scope.row[column.prop]}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// import noDate from '../nodate.vue'
import tabs from './tabs.vue'
import search from './search.vue'
import { wxConfig } from '../../../utils/wxConfig'
import { getMenuConfig, getSearchList, getTableData } from '../../../utils/api/jierun'
export default {
  components: { tabs, search },
  data() {
    return {
      tabsList: [
        {
          paneName: 'techReportSubmitAudit', // 安全服务部X月计划完成反馈
          label: '技术报告提交及审核情况'
        },
        {
          paneName: 'qaDeptMonthReportAudit', // 安全服务部X月计划任务
          label: '月度报告审核情况'
        }
      ],
      model: 'quality_report',
      value1: '',
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      page: 1,
      pageSize: 40,
      pageNum: 0,
      activeTab: {
        paneName: 'techReportSubmitAudit', // 安全服务部X月计划完成反馈
        label: '技术报告提交及审核情况'
      },
      // 表格数据
      tableData: [],
      // 表格列配置
      tableColumns: [],
      // 查询条件
      searchList: [],
      // 新增：加载状态，防止重复请求
      loading: false,
      // 新增：标记是否首次加载完成
      isFirstLoad: false
    }
  },
  watch: {
    tableData: {
      deep: true,
      handler: function() {
        this.updateTableLayout()
      }
    },
    tableColumns: {
      deep: true,
      handler: function() {
        this.updateTableLayout()
      }
    },
    model: {
      immediate: true, // 首次加载时触发
      handler(newVal) {
        if (newVal) {
          this.fetchTabData()
        }
      }
    }
  },
  mounted() {
    if (this.channel === 'wechat') {
      wxConfig()
      setTimeout(() => {
        // this.getUserKPIList()
      }, 500)
    } else {
      // this.getUserKPIList()
    }
  },
  methods: {
    updateTableLayout() {
      this.$nextTick(() => {
        const doLayout = () => {
          if (this.$refs.table && this.$refs.table.doLayout) {
            this.$refs.table.doLayout()
          }
        }
        doLayout()
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(doLayout)
        }
        setTimeout(doLayout, 100)
      })
    },
    fetchTabData() {
      if (this.loading) return // 防止重复请求
      this.loading = true
      // 清空旧数据，避免视觉混淆
      this.tableData = []
      this.tableColumns = []
      this.searchList = []
      Promise.all([
        this.getMenuConfig(),
        this.getSearchList()
      ]).then(() => {
        // 两个接口都完成后，再执行表格数据请求
        return this.getTableData()
      }).finally(() => {
        this.loading = false
        this.isFirstLoad = true
        this.updateTableLayout()
      })
    },
    // 获取表头（改为返回Promise，支持并行请求）
    getMenuConfig() {
      const params = {
        model: this.model
      }
      return getMenuConfig(params).then((data) => {
        if (data.code === 10000) {
          this.tableColumns = data.result
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log('获取表头失败：', error)
        this.loading = false
      })
    },
    // 获取查询条件（改为返回Promise，支持并行请求）
    getSearchList() {
      const params = {
        model: this.model
      }
      return getSearchList(params).then((data) => {
        if (data.code === 10000) {
          this.searchList = (data?.result || []).map(item => ({
            ...item,
            date: []
          }))
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log('获取查询条件失败：', error)
        this.loading = false
      })
    },
    // 获取表格数据
    getTableData() {
      // 增加空值保护
      if (!this.model) return

      const page = this.page
      const pageSize = this.pageSize
      const searchData = this.searchList.map(item => {
        const result = {}
        const propKey = item.prop
        result[propKey] = item.defaultValue
        return result
      })
      const date = {
        model: this.model,
        searchData: searchData
      }
      return getTableData(page, pageSize, date).then((data) => {
        if (data.code === 10000) {
          this.tableData = data.result.list
          this.pageNum = data.result.pages
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log('获取表格数据失败：', error)
      }).finally(() => {
        this.updateTableLayout()
        // 关闭临时loading
      })
    },
    // 修改时间
    changeDate(list) {
      this.searchList = this.searchList.map((item) => {
        if (item.type === list.type) {
          return {
            ...item,
            defaultValue: list.defaultValue
          }
        }
        return item
      })
      // 重置页码，重新加载第一页
      this.page = 1
      this.getTableData()
    },
    // 无限滚动
    loadList() {
      if (this.pageNum > this.page) {
        this.page += 1
        this.getTableData1()
      }
    },
    getTableData1() {
      this.loading = true
      const page = this.page
      const pageSize = this.pageSize
      const searchData = this.searchList.map(item => {
        const result = {}
        const propKey = item.prop
        result[propKey] = item.defaultValue
        return result
      })
      const date = {
        model: this.model,
        searchData: searchData
      }
      getTableData(page, pageSize, date).then((data) => {
        if (data.code === 10000) {
          this.tableData = [...this.tableData, ...data.result.list]
          this.pageNum = data.result.pages
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log(error)
      }).finally(() => {
        this.loading = false
        this.updateTableLayout()
      })
    },
    // 切换标签页时更新表格数据和列
    handleTabChange(tab) {
      this.activeTab = tab
      this.page = 1
      switch (tab.paneName) {
        case 'techReportSubmitAudit':
          this.model = 'quality_report'
          break
        case 'qaDeptMonthReportAudit':
          this.model = 'quality_review'
          break
      }
      this.updateTableLayout()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/index.scss';
.mine {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
   .mine_headers{
    flex-shrink: 0;
    margin: 12px 0 15px;
    width: 100%;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
  }
  .date_box{
    text-align: left;
  }
}
.table_box{
  flex: 1;
  min-height: 0;
  width: calc(100% - 34px);
  margin-left: 15px;
  overflow: hidden;
}
::v-deep .el-tabs__nav-scroll{
  padding: 0 40px 0 0 !important;
}
::v-deep .el-tabs{
  width: 100% !important;
}
::v-deep .scpc-task-table{
  height: 100% !important;
}
::v-deep .scpc-task-table .el-table__body-wrapper{
  overflow: auto !important;
}
::v-deep .el-table .cell{
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
  height: auto !important;
  line-height: normal !important;
  padding: 10px !important
}
</style>
